import clsx from 'clsx';
import { Typography } from '../typography';

import { Category } from '@/interfaces';
import { useClaimIcons } from '@/hooks';

interface Props {
	type: Category;
	size?: 'small' | 'medium' | 'big';
}
export type BadgeTypes =
	| 'whistleblower'
	| 'commodities'
	| 'securities'
	| 'antitrust'
	| 'health_care'
	| 'commercial'
	| 'data_privacy'
	| 'consumer_protection';
export const Badge: React.FC<Props> = ({ type, size = 'medium' }) => {
	const { getIcon } = useClaimIcons();
	const formattedName = type.replaceAll('_', ' ');
	const formattedType = type?.toLowerCase()?.replace(' ', '_') as BadgeTypes;
	const categoryColors: Record<BadgeTypes, { bg: string; text: string }> = {
		whistleblower: { bg: 'bg-[#FF004333]', text: '!text-[#FF0043]' },
		commodities: { bg: 'bg-[#C0D65333]', text: '!text-[#A0B245]' },
		securities: { bg: 'bg-[#EB35CE33]', text: '!text-[#EB35CE]' },
		antitrust: { bg: 'bg-[#40BB7126]', text: '!text-[#40BB71]' },
		health_care: { bg: 'bg-[#2084E726]', text: '!text-[#2084E7]' },
		commercial: { bg: 'bg-[#2D41F54D]', text: '!text-[#2D41F5]' },
		data_privacy: { bg: 'bg-[#FD983440]', text: '!text-[#FD9834]' },
		consumer_protection: { bg: 'bg-[#8F20EF33]', text: '!text-[#8F20EF]' },
	};

	const colors = categoryColors[formattedType];

	return (
		<div
			className={clsx(
				'bg-opacity-20 w-fit capitalize inline-flex items-center gap-1',
				colors.bg,
				{
					'py-[5px] px-2 rounded-lg': size === 'small',
					'py-2 px-3 rounded-xl': size === 'medium',
				}
			)}
		>
			{getIcon(formattedType)}
			<Typography
				type={size === 'small' ? 'semibold-12' : 'semibold-14'}
				className={clsx(colors.text)}
			>
				{formattedName}
			</Typography>
		</div>
	);
};
